import { ORGANIZATION_FIELDS_METADATA } from "../config/userUploaderConfig";

export function generateCsvTemplate(): string {
  const headers: string[] = [];
  const sampleRow: string[] = [];

  for (const field of ORGANIZATION_FIELDS_METADATA) {
    if (field.hidden) continue;
    headers.push(field.displayName);

    let sample = "";
    if (field.type === "boolean") {
      sample = field.defaultValue !== undefined ? String(field.defaultValue) : "true";
    } else if (field.type === "number") {
      sample = field.key === "latitude" || field.key === "longitude" ? "4.7110" : "0";
    } else if (field.type === "string[]") {
      sample = "3001234567,3109876543";
    } else if (field.parser === "crops") {
      sample = "Cafe:10.5,Platano:5.2";
    } else if (field.selectOptions && field.selectOptions.length > 0) {
      sample = field.selectOptions[0].value;
    } else {
      sample = `Ejemplo ${field.displayName}`;
    }
    sampleRow.push(sample);
  }

  const escapeCell = (val: string): string => {
    if (val.includes(",") || val.includes('"') || val.includes("\n")) {
      return `"${val.replace(/"/g, '""')}"`;
    }
    return val;
  };

  const headerLine = headers.map(escapeCell).join(",");
  const sampleLine = sampleRow.map(escapeCell).join(",");
  return `${headerLine}\n${sampleLine}\n`;
}

export function downloadCsvTemplate(): void {
  const csv = generateCsvTemplate();
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "plantilla-importacion-organizaciones.csv";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
